export default {
  dependent: {
    type: Object,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/components/kinsfolk/resources/props.js